import Abstract from "./abstract";

const FillableTextElementType = {
  NAME: `name`,
  SURNAME: `surname`,
  PATRONYMIC: `patronymic`,
  PHONE: `phone`,
  EMAIL: `email`,
};

const textValue = {
  [FillableTextElementType.NAME]: (value) => value,
  [FillableTextElementType.PHONE]: (value) => value,
  [FillableTextElementType.EMAIL]: (value) => value,
};

export default class User extends Abstract {
  #nameElement = this.item.querySelector(`[data-input-fill-name="${FillableTextElementType.NAME}"]`);
  #surnameElement = this.item.querySelector(`[data-input-fill-name="${FillableTextElementType.SURNAME}"]`);
  #phoneElement = this.item.querySelector(`[data-input-fill-name="${FillableTextElementType.PHONE}"]`);
  #emailElement = this.item.querySelector(`[data-input-fill-name="${FillableTextElementType.EMAIL}"]`);
  #patronymicElement = this.item.querySelector(`[data-input-fill-name="${FillableTextElementType.PATRONYMIC}"]`);

  #name = this.#nameElement.value;
  #surname = this.#surnameElement.value;
  #phone = this.#phoneElement.value;
  #email = this.#emailElement.value;
  #patronymic = this.#patronymicElement.value;

  #fillableTextElements = this.item.querySelectorAll(`.js-fill-text`);

  constructor(item) {
    super(item);
  }

  getSubmitStatus() {
    return (
      this.#name !== this.#nameElement.value ||
      this.#surname !== this.#surnameElement.value ||
      this.#phone !== this.#phoneElement.value ||
      this.#email !== this.#emailElement.value ||
      this.#patronymic !== this.#patronymicElement.value
    );
  }

  submitForm(evt) {
    super.submitForm(evt);
  }

  fillTextElements() {
    super.fillTextElements();

    if (this.getSubmitStatus()) {
      this.#fillableTextElements.forEach((textElement) => {
        const type = textElement.dataset.fillType;
        let value;

        switch (type) {
          case FillableTextElementType.NAME:
            value = `${this.item.querySelector(`[data-input-fill-name="${FillableTextElementType.SURNAME}"]`).value} ${
              this.item.querySelector(`[data-input-fill-name="${FillableTextElementType.NAME}"]`).value
            } ${this.item.querySelector(`[data-input-fill-name="${FillableTextElementType.PATRONYMIC}"]`).value}`;
            break;
          default:
            value = this.item.querySelector(`[data-input-fill-name="${type}"]`).value;
            break;
        }

        textElement.textContent = textValue[type](value);
      });
    }
  }
}
